<template>
  <div>
    <div class="row">
      <div v-if="data.default == 0" class="col-md-12 pt-0 pb-0">
        <label>Tipo de conta</label>
        <div>
          <div class="form-check form-check-inline">
            <input
              v-model="type"
              class="form-check-input"
              type="radio"
              name="type"
              id="bank"
              value="bank"
            />
            <label class="form-check-label" for="bank">Conta bancário</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              v-model="type"
              class="form-check-input"
              type="radio"
              name="type"
              id="other"
              value="other"
            />
            <label class="form-check-label" for="other">Outra</label>
          </div>
        </div>
      </div>
      <div v-if="type == 'bank'" class="col-md-8 pt-0 pb-0">
        <label>Banco</label>
        <treeselect
          :multiple="false"
          :options="[{ id: '', label: 'SELECIONE...', children: [] }, ...banks]"
          placeholder="SELECIONE..."
          v-model="bank_id"
          noChildrenText="NÃO POSSUI BANCO(S) FILHO(S)"
        />
      </div>
      <div v-if="type == 'bank'" class="col-md-4 pt-0 pb-0">
        <label>Tipo</label>
        <select v-model="account_type" class="form-control">
          <option value="CORRENTE">CORRENTE</option>
          <option value="POUPANCA">POUPANÇA</option>
        </select>
      </div>
      <div v-if="type == 'bank'" class="col-md-3 pt-0 pb-0">
        <label>Agência</label>
        <input type="text" class="form-control" v-model="agency" />
      </div>
      <div v-if="type == 'bank'" class="col-md-3 pt-0 pb-0">
        <label>Conta</label>
        <input type="text" class="form-control" v-model="account" />
      </div>
      <div v-if="type == 'bank'" class="col-md-3 pt-0 pb-0">
        <label>- DV</label>
        <input type="text" class="form-control" v-model="account_dv" />
      </div>
      <div
        v-if="type == 'bank' && convenio == 'config'"
        class="col-md-3 pt-0 pb-0"
      >
        <label>Convênio</label>
        <input type="text" class="form-control" v-model="agreement" />
        <label>Carteira</label>
        <input type="text" class="form-control" v-model="carteira" />
      </div>
      <div v-if="type == 'bank'" class="col-md-3 pt-0 pb-0">
        <label>Carteira</label>
        <input type="text" class="form-control" v-model="carteira" />
      </div>
      <div v-if="type == 'bank'" class="col-md-3 pt-0 pb-0">
        <label>Telefone</label>
        <input type="text" class="form-control" v-model="telephone" />
      </div>
      <div class="col-md-6 pt-0 pb-0">
        <LabelRequiredField label="Apelido da conta" />
        <input type="text" class="form-control" v-model="account_nickname" />
      </div>
      <div class="col-md-3 pt-0 pb-0">
        <LabelRequiredField label="Data de início" />
        <input type="date" class="form-control" v-model="start_date" />
      </div>
      <div class="col-md-3 pt-0 pb-0">
        <LabelRequiredField label="Saldo nesta data" />
        <input
          type="text"
          class="form-control"
          v-model="balance_date"
          @input="handleInputBalanceDate($event.target.value)"
        />
      </div>
      <div class="col-md-6 pt-0 pb-0">
        <label>Sequencial atual do Nosso Número</label>
        <input
          type="number"
          class="form-control"
          v-model="current_sequence_of_our_number"
        />
      </div>
      <div v-if="type == 'bank'" class="col-md-3 pt-0 pb-0">
        <label>Gerente</label>
        <input type="text" class="form-control" v-model="manager" />
      </div>
      <div v-if="data.default == 0" class="col-md-6 pt-0 pb-0">
        <label>Situação da conta</label>
        <div>
          <div class="form-check form-check-inline">
            <input
              v-model="account_status"
              class="form-check-input"
              type="radio"
              name="account_status"
              id="negative"
              value="0"
            />
            <label
              class="form-check-label v-danger p-1 pl-2 pr-2 noBorderRadius"
              for="negative"
              >Negativo</label
            >
          </div>
          <div class="form-check form-check-inline">
            <input
              v-model="account_status"
              class="form-check-input"
              type="radio"
              name="account_status"
              id="positive"
              value="1"
            />
            <label
              class="form-check-label v-success p-1 pl-2 pr-2 noBorderRadius"
              for="positive"
              >Positivo</label
            >
          </div>
        </div>
      </div>
      <div v-if="data.default == 0" class="col-md-6">
        <label>Agrupamento</label>
        <select v-model="grouping_id" class="form-control">
          <option v-if="grouping_id" value="">Sem agrupamento</option>
          <option v-for="(item, key) in groupings" :value="item.id" :key="key">
            {{ item.description }}
          </option>
        </select>
      </div>
      <div v-if="data.default == 0" class="col-md-8 pt-0 pb-0">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="allows_releases"
            id="allows_releases"
          />
          <label class="form-check-label" for="allows_releases">
            Permite lançamento(s)
          </label>
        </div>
        <small
          >Contas que NÃO permitem lançamentos podem apenas receber créditos e
          débitos através de Transferências.</small
        >
      </div>
      <div v-if="data.default == 0" class="col-md-4 pt-0 pb-0">
        <label>Status</label>
        <select v-model="status" class="form-control">
          <option value="1">ATIVO</option>
          <option value="0">INATIVO</option>
        </select>
      </div>
    </div>
    <div class="mt-2" v-if="false">
      <h1>Configurações do boleto</h1>
      <table class="table table-sm">
        <tbody>
          <tr
            style="background-color: #1f5a76 !important; color: #fff !important"
          >
            <th colspan="2">Multa</th>
          </tr>
          <tr>
            <td>
              <label>Tipo de aplicação</label>
              <select v-model="penalty_type" class="form-control">
                <option value="0">Isento - Não registra multa</option>
                <option value="1">Valor em Reais</option>
                <option value="2">Valor em percentual</option>
              </select>
            </td>
            <td>
              <label>Valor</label>
              <div class="input-group">
                <div class="input-group-append">
                  <button
                    class="btn border"
                    v-if="penalty_type == 1"
                    type="button"
                  >
                    R$
                  </button>
                  <button class="btn border" v-else type="button">%</button>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="penalty_value"
                  maxlength="13"
                  @input="
                    handleInputValue($event.target.value, 'penalty_value')
                  "
                />
              </div>
            </td>
          </tr>
          <tr
            style="background-color: #1f5a76 !important; color: #fff !important"
          >
            <th colspan="2">Juros</th>
          </tr>
          <tr>
            <td>
              <label>Tipo de aplicação</label>
              <select v-model="interest_type" class="form-control">
                <option value="3">Isento - Não registra juros</option>
                <option value="1">Valor por dia</option>
                <option value="2">Taxa mensal</option>
              </select>
            </td>
            <td>
              <label>Valor</label>
              <div class="input-group">
                <div class="input-group-append">
                  <button
                    class="btn border"
                    v-if="interest_type == 1"
                    type="button"
                  >
                    R$
                  </button>
                  <button class="btn border" v-else type="button">%</button>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="interest_value"
                  maxlength="13"
                  @input="
                    handleInputValue($event.target.value, 'interest_value')
                  "
                />
              </div>
            </td>
          </tr>
          <tr
            style="background-color: #1f5a76 !important; color: #fff !important"
          >
            <th colspan="2">Desconto</th>
          </tr>
          <tr>
            <td>
              <label>Tipo de aplicação</label>
              <select v-model="discount_type" class="form-control">
                <option value="0">Sem instrução de pagamento</option>
                <option value="1">Valor Fixo Até a Data Informada</option>
                <option value="2">Percentual Até a Data Informada</option>
                <option value="3">Valor por Antecipação Dia Corrido</option>
                <option value="4">Valor por Antecipação Dia Útil</option>
                <option value="5">
                  Percentual Sobre o Valor Nominal Dia Corrido
                </option>
                <option value="6">
                  Percentual Sobre o Valor Nominal Dia Útil
                </option>
              </select>
            </td>
            <td>
              <label>Valor</label>
              <div class="input-group">
                <div class="input-group-append">
                  <button
                    class="btn border"
                    v-if="['1', '3', '4'].includes(discount_type)"
                    type="button"
                  >
                    R$
                  </button>
                  <button class="btn border" v-else type="button">%</button>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-model="discount_value"
                  maxlength="13"
                  @input="
                    handleInputValue($event.target.value, 'discount_value')
                  "
                />
              </div>
            </td>
          </tr>
          <tr
            style="background-color: #1f5a76 !important; color: #fff !important"
          >
            <th colspan="2">Protesto</th>
          </tr>
          <tr>
            <td>
              <label> Tipo de protesto </label>
              <select v-model="protest_type" class="form-control">
                <option value="1">Protestar Dias Corridos</option>
                <option value="2">Protestar Dias Úteis</option>
                <option value="3">Não Protestar</option>
                <option value="4">Protestar Fim Falimentar - Dias Úteis</option>
                <option value="5">
                  Protestar Fim Falimentar - Dias Corridos
                </option>
                <option value="8">Negativação sem Protesto</option>
                <option value="9">Cancelamento Protesto Automático</option>
              </select>
            </td>
            <td>
              <label>Quantidade de dias</label>
              <input
                type="text"
                class="form-control"
                v-model="protest_days"
                maxlength="2"
              />
              <small>(após o vencimento para realizar o protesto)</small>
            </td>
          </tr>
          <tr
            style="background-color: #1f5a76 !important; color: #fff !important"
          >
            <th colspan="2">Baixa</th>
          </tr>
          <tr>
            <td>
              <label> Tipo de baixa </label>
              <select v-model="downpayment_type" class="form-control">
                <option value="1">Baixar/Devolver</option>
                <option value="2">Não baixar / Não devolver</option>
                <option value="3">Cancelar prazo para baixa / Devolução</option>
              </select>
            </td>
            <td>
              <label>Quantidade de dias</label>
              <input
                type="text"
                class="form-control"
                v-model="downpayment_days"
                maxlength="2"
              />
              <small>(após o vencimento para realizar a baixa)</small>
            </td>
          </tr>
          <tr
            style="background-color: #1f5a76 !important; color: #fff !important"
          >
            <th colspan="2">Dados diversos do boleto</th>
          </tr>
          <tr>
            <td>
              <label> Impressão do boleto </label>
              <select v-model="ticket_print" class="form-control">
                <option value="A">Impressão será realizado pelo banco</option>
                <option value="B">
                  Impressão será realizado pelo beneficiário
                </option>
              </select>
            </td>
            <td>
              <label> Categoria do boleto </label>
              <select v-model="ticket_category" class="form-control">
                <option value="1">Sem Registro</option>
                <option value="2">Com Registro</option>
                <option value="3">Impressão pelo banco</option>
              </select>
            </td>
          </tr>
          <tr>
            <td>
              <label> Postagem do boleto </label>
              <select v-model="ticket_post" class="form-control">
                <option value="S">Postagem pelo banco</option>
                <option value="N">
                  Postagem por responsabilidade do cedente
                </option>
              </select>
            </td>
            <td>
              <label>Acréscimo que deve ser somado ao valor do boleto</label>
              <input
                type="text"
                class="form-control"
                v-model="increment_value"
                maxlength="12"
              />
            </td>
          </tr>
          <tr>
            <td>
              <label>Campo livre para informações adicionais do boleto</label>
              <textarea
                v-model="additional_information"
                rows="3"
                class="form-control"
              />
              <small
                >(A informação será exibida logo abaixo dos dados do
                pagador)</small
              >
            </td>
            <td>
              <label
                >Conteúdo que será exibido ao lado do texto "Instruções"</label
              >
              <textarea
                v-model="ticket_instructions"
                rows="3"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <td>
              <label>Informar o local do pagamento</label>
              <textarea v-model="payment_local" rows="3" class="form-control" />
            </td>
            <td>
              <label>O pagador aceitou o boleto?</label>
              <select v-model="ticket_payer_accept" class="form-control">
                <option value="S">Aceito</option>
                <option value="N">Não aceito</option>
              </select>
              <small
                >Ele autorizou, assinou o documento de cobrança que originou o
                boleto.</small
              >
            </td>
          </tr>
          <tr>
            <td>
              <label>Tipo do boleto emitido</label>
              <select v-model="ticket_issue_type" class="form-control">
                <option value="01">Duplicata Mercantil</option>
                <option value="02">Nota promissória</option>
                <option value="03">Nota de seguro</option>
                <option value="04">Duplicata de Serviço</option>
                <option value="05">Recibo</option>
                <option value="06">Letra de Câmbio</option>
                <option value="07">Nota de Débito</option>
                <option value="08">Boleto de Proposta</option>
                <option value="09">Letra de Câmbio</option>
                <option value="10">Warrant</option>
                <option value="11">Cheque</option>
                <option value="12">Cobrança Seriada</option>
                <option value="13">Mensalidade escolar</option>
                <option value="14">Apólice de Seguro</option>
                <option value="15">Documento de Dívida</option>
                <option value="16">Encargos Condominiais</option>
                <option value="17">Conta de prestação de serviço</option>
                <option value="18">Contrato</option>
                <option value="19">Cosseguro</option>
                <option value="20">Duplicata Rural</option>
                <option value="21">Nota Promissória Rural</option>
                <option value="22">Dívida Ativa da União</option>
                <option value="23">Dívida Ativa de Estado</option>
                <option value="24">Dívida Ativa de Município</option>
                <option value="25">Duplicata Mercantil por Indicação</option>
                <option value="26">Duplicata de Serviço por Indicação</option>
                <option value="27">Nota de Crédito Comercial</option>
                <option value="28">Nota de Crédito para Exportação</option>
                <option value="29">Nota de Crédito Industrial</option>
                <option value="30">Nota de Crédito Rural</option>
                <option value="32">Triplicata Mercantil</option>
                <option value="33">Triplicata de Serviço</option>
                <option value="34">Fatura</option>
                <option value="35">Parcela de Consórcio</option>
                <option value="36">Nota Fiscal</option>
                <option value="37">Cédula de Produto Rural</option>
                <option value="38">Cartão de crédito</option>
                <option value="39">Títulos de Terceiros</option>
                <option value="40">Boleto de Depósito e Aporte</option>
                <option value="41">
                  Cédula de Crédito Bancário por Indicação - CBI
                </option>
                <option value="42">Contrato de Câmbio - CC</option>
                <option value="43">Cédula de Crédito Bancário - CCB</option>
                <option value="44">Confissão de Dívida - CD</option>
                <option value="45">Contrato de Mútuo - CM</option>
                <option value="46">Recibo de Aluguel (PJ) - RA</option>
                <option value="47">TA - Termo de acordo</option>
                <option value="99">DV Outros</option>
              </select>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- FIM BAIXA AUTOMATICA -->
    <div class="row">
      <div class="col-md-12 pt-0 pb-0">
        <ErrorsMessages :errors="errors" />
      </div>
      <div class="col-md-12 text-right">
        <v-btn :disabled="loading" @click="update" class="btn-save">
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import LabelRequiredField from "../../../Components/LabelRequiredField";

import Treeselect from "@riophae/vue-treeselect";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import moment from "moment";

import {
  formatValueNegativeOnKeyUp,
  formatValueOnKeyUp,
} from "../../../../lib/format";

export default {
  name: "Edit",
  props: {
    data: Object,
    groupings: Array,
    banks: Array,
  },
  components: {
    ErrorsMessages,
    LabelRequiredField,
    Treeselect,
  },
  data() {
    return {
      bank_id: "",
      account_type: "",
      type: "bank",
      agency: "",
      account: "",
      account_dv: "",
      agreement: "",
      carteira: "",
      manager: "",
      telephone: "",
      account_nickname: "",
      start_date: moment().format("YYYY-MM-DD"),
      balance_date: "",
      current_sequence_of_our_number: "",
      account_status: 1,
      status: 1,
      grouping_id: "",
      allows_releases: "",
      loading: false,
      errors: [],
      penalty_type: 0,
      penalty_value: "",
      interest_type: 3,
      interest_value: "",
      discount_type: 0,
      discount_value: "",
      protest_type: 3,
      protest_days: 0,
      downpayment_type: 1,
      downpayment_value: 0,
      ticket_print: "A",
      ticket_category: 3,
      ticket_post: "S",
      increment_value: 0,
      additional_information: "",
      ticket_instructions: "",
      payment_local: "Pagável em qualquer banco até o vencimento.",
      ticket_payer_accept: "S",
      ticket_issue_type: "01",
      convenio: null,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatValueOnKeyUp,
    formatValueNegativeOnKeyUp,
    handleInputBalanceDate(balance_date) {
      this.balance_date = formatValueOnKeyUp(balance_date);
    },
    handleInputValue(value, key) {
      this[key] = formatValueOnKeyUp(value);
    },
    async retrieve() {
      let { convenio } = this.$router.currentRoute.query;

      let { data } = this;

      this.convenio = convenio;
      this.bank_id = data.bank_id;
      this.account_type = data.account_type;
      this.type = data.type;
      this.agency = data.agency;
      this.account = data.account;
      this.account_dv = data.account_dv;
      this.agreement = data.agreement;
      this.carteira = data.carteira;
      this.manager = data.manager;
      this.telephone = data.telephone;
      this.account_nickname = data.account_nickname;
      this.start_date = moment(data.start_date).format("YYYY-MM-DD");
      this.balance_date = formatValueOnKeyUp(data.balance_date);
      this.current_sequence_of_our_number = data.current_sequence_of_our_number;
      this.account_status = data.account_status;
      this.status = data.status;
      this.grouping_id = data.finance_configuration_grouping_id;
      this.allows_releases = data.allows_releases;
      this.penalty_type = data.penalty_type;
      this.penalty_value = formatValueOnKeyUp(
        String(parseFloat(data.penalty_value).toFixed(2))
      );
      this.interest_type = data.interest_type;
      this.interest_value = formatValueOnKeyUp(
        String(parseFloat(data.interest_value).toFixed(2))
      );
      this.discount_type = data.discount_type;
      this.discount_value = formatValueOnKeyUp(
        String(parseFloat(data.discount_value).toFixed(2))
      );
      this.protest_type = data.protest_type;
      this.protest_days = data.protest_days;
      this.downpayment_type = data.downpayment_type;
      this.downpayment_days = data.downpayment_days;
      this.ticket_print = data.ticket_print;
      this.ticket_category = data.ticket_category;
      this.ticket_post = data.ticket_post;
      this.increment_value = data.increment_value;
      this.additional_information = data.additional_information;
      this.ticket_instructions = data.ticket_instructions;
      this.payment_local = data.payment_local;
      this.ticket_payer_accept = data.ticket_payer_accept;
      this.ticket_issue_type = String(data.ticket_issue_type).padStart(2, "0");
    },
    async update() {
      try {
        this.loading = true;

        const {
          data,
          bank_id,
          account_type,
          type,
          agency,
          account,
          account_dv,
          agreement,
          carteira,
          manager,
          telephone,
          account_nickname,
          start_date,
          balance_date,
          current_sequence_of_our_number,
          account_status,
          status,
          grouping_id,
          allows_releases,
          penalty_type,
          penalty_value,
          interest_type,
          interest_value,
          discount_type,
          discount_value,
          protest_type,
          protest_days,
          downpayment_type,
          downpayment_days,
          convenio,
          ticket_print,
          ticket_category,
          ticket_post,
          increment_value,
          additional_information,
          ticket_instructions,
          ticket_issue_type,
          payment_local,
          ticket_payer_accept,
        } = this;

        let params = {
          id: data.id,
          bank_id,
          account_type,
          type,
          agency,
          account,
          account_dv,
          agreement,
          carteira,
          manager,
          telephone,
          account_nickname,
          start_date,
          balance_date,
          current_sequence_of_our_number,
          account_status,
          status,
          grouping_id,
          allows_releases,
          penalty_type,
          penalty_value,
          interest_type,
          interest_value,
          discount_type,
          discount_value,
          protest_type,
          protest_days,
          downpayment_type,
          downpayment_days,
          convenio,
          ticket_print,
          ticket_category,
          ticket_post,
          increment_value,
          additional_information,
          ticket_instructions,
          ticket_issue_type,
          payment_local,
          ticket_payer_accept,
        };

        const response = await api.put(
          "/rest-home/financial/configuration/account",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$bvModal.hide(`edit-account-${data.id}`);

          this.$emit("success");

          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

